import React from 'react';
import cx from 'classnames';

class SlideshowModule extends React.Component {
  constructor(props) {
    super();
    this.state = {
      slide: 0,
      flky: null,
    };
    this.slideshow = React.createRef();
  }

  componentDidMount() {
    require('flickity-bg-lazyload');
    const Flickity = require('flickity');
    const flky = new Flickity(this.slideshow.current, {
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      bgLazyLoad: 2,
      wrapAround: true,
    });
    this.setState({
      flky: flky,
    });
    setTimeout(() => {
      flky.resize();
    }, 200);
    flky.on('change', index => {
      this.setState({
        slide: index,
      });
    });
  }

  render() {
    const { media, layoutStyle } = this.props.data;
    return (
      <div className="rel">
        <div
          className={cx('slideshow__wrapper py1', {
            x: layoutStyle === 'full',
            'container--xl ma': layoutStyle === 'inline',
          })}
        >
          <div className="slideshow__article" ref={this.slideshow}>
            {media.map((single, i) => {
              return (
                <div
                  key={i}
                  className="slideshow__article-slide x"
                  data-flickity-bg-lazyload={`${single.fields.file.url}?fm=jpg&q=80&fl=progressive`}
                >
                  <img
                    src={`${media[0].fields.file.url}?fm=jpg&q=80&fl=progressive`}
                    alt=""
                  />
                </div>
              );
            })}
          </div>
          <div className="container--m ma x px1 ac f jcc aic slideshow__article-controls">
            <div
              className="slideshow__article-controls-s f aic jcc"
              onClick={() => this.state.flky.previous()}
            >
              <span className="slideshow__article-left inline-block" />
            </div>
            <span className="slideshow__article-icon inline-block" />
            <div
              className="slideshow__article-controls-s f aic jcc"
              onClick={() => this.state.flky.next()}
            >
              <span className="slideshow__article-right inline-block" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SlideshowModule;
